import { styled } from 'styled-components';
import { IoChevronUp, IoChevronDown } from 'react-icons/io5';

import useGroupName from '../hooks/useGroupName';
import { GroupBlockData } from 'types';

const Container = styled.div<{ $isExpand?: boolean; $isSelected?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${(props) => props.theme.ui.button.iconButtonBgColor};
  padding: 6px 10px;
  font-size: 14px;
  font-weight: 500;
  gap: 10px;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;

  ${(props) => {
    if (props.$isExpand) {
      return {
        position: 'absolute',
        backgroundColor: 'transparent',
        width: '100%',
        transform: 'translateY(-100%)',
        padding: '6px 0',
        color: props.$isSelected ? props.theme.global.mainColor : props.theme.global.lightTextColor,
      };
    }
  }}
`;

const NameView = styled.div`
  display: flex;
  align-items: center;
  font-size: 13px;
  gap: 6px;
  width: 100%;

  img {
    width: 18px;
  }

  input {
    font-size: 13px;
    width: 100%;
    background-color: ${(props) => props.theme.global.bgColor};
    color: ${(props) => props.theme.global.textColor};
  }
`;

const ButtonView = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  button,
  a {
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      font-size: 18px;
    }
  }
`;

const ExpandButton = styled.button`
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 18px;
`;

interface GroupNodeHeaderProps {
  id: string;
  data: GroupBlockData;
  isSelected: boolean;
  onExpandClick: () => void;
}

const GroupNodeHeader = ({ id, data, isSelected, onExpandClick }: GroupNodeHeaderProps) => {
  const { inputRef, name, isEditMode, onEnterPress, onNameChange, onNameDoubleClick, onSaveName } = useGroupName({
    id,
    initName: data.name,
  });

  return (
    <Container $isExpand={data.expand} $isSelected={isSelected}>
      <NameView>
        {isEditMode ? (
          <input
            {...(isSelected && { className: 'nodrag' })}
            ref={inputRef}
            value={name}
            onChange={onNameChange}
            onBlur={onSaveName}
            onKeyDown={onEnterPress}
          />
        ) : (
          <span onDoubleClick={onNameDoubleClick}>{data.name}</span>
        )}
      </NameView>
      <ButtonView>
        <ExpandButton onClick={onExpandClick}>{data.expand ? <IoChevronUp /> : <IoChevronDown />}</ExpandButton>
      </ButtonView>
    </Container>
  );
};

export default GroupNodeHeader;
